module.exports = new __parcel__URL__("periscope-page-full-layout.tpl.762dcdba.svg").toString();